export default __webpack_public_path__ + "static/media/gana.5ae539c0.png";